export default {

    formRow: {
        display: "flex",
        columnGap: "40px"
    },

    fieldContainer: {
        width: "60%"
    },
    recipientsFieldsContainer: {
        display: 'flex',
        flex: '1 1 0%',
         width: '66%',
    },
    recipientBatch1Container: {
        display: 'flex', 
        flexDirection: 'column', 
        width: '85%',
    },
    recipientBatch2Container: {
        display: 'flex', 
        flexDirection: 'column', 
        width: '83%',
        marginLeft: '3%',
    }
}